import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FormState {
  selectedSegment: string;
  selectedStates: string[];
  selectedAvailablePack: number | null;
  selectedReplacedPack: number | null;
  priceInput: number;
  distributionSelected: string;
  noOfIntervention: number;
  entries: Array<{
    bottler: string[];
    state: string[];
    category: string[];
    pack_segment: string[];
    pack_size: number[];
    brand: string[];
    price: number;
    distribution: string;
    intervention_type: string;
  }>;
}

const initialState: FormState = {
  selectedSegment: '',
  selectedStates: [],
  selectedAvailablePack: null,
  selectedReplacedPack: null,
  priceInput: 0,
  distributionSelected: '',
  entries: [],
  noOfIntervention: 0,
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setSelectedSegment: (state, action: PayloadAction<string>) => {
      state.selectedSegment = action.payload;
      state.selectedAvailablePack = null;
      state.priceInput = 0;
    },
    toggleState: (state, action: PayloadAction<string>) => {
      const stateName = action.payload;
      if (state.selectedStates.includes(stateName)) {
        state.selectedStates = state.selectedStates.filter((name) => name !== stateName);
      } else {
        state.selectedStates.push(stateName);
      }
    },
    setSelectedAvailablePack: (state, action: PayloadAction<number | null>) => {
      state.selectedAvailablePack = action.payload;
    },
    setSelectedReplacedPack: (state, action: PayloadAction<number | null>) => {
      state.selectedReplacedPack = action.payload;
    },
    setPriceInput: (state, action: PayloadAction<number>) => {
      state.priceInput = action.payload;
    },
    setDistributionSelected: (state, action: PayloadAction<string>) => {
      state.distributionSelected = action.payload;
    },
    setNoOfInterventions: (state, action: PayloadAction<number>) => {
      state.noOfIntervention = action.payload;
    },
    addEntry: (
      state,
      action: PayloadAction<{
        bottler: string[];
        state: string[];
        category: string[];
        pack_segment: string[];
        pack_size: number[];
        brand: string[];
        price: number;
        distribution: string;
        intervention_type: string;
      }>,
    ) => {
      state.entries.push(action.payload);
    },
    resetForm: () => {
      return initialState;
    },
    resetEntries: (state) => {
      state.entries = [];
    },
  },
});

export const {
  setSelectedSegment,
  toggleState,
  setSelectedAvailablePack,
  setPriceInput,
  setDistributionSelected,
  addEntry,
  resetForm,
  resetEntries,
  setNoOfInterventions,
  setSelectedReplacedPack,
} = formSlice.actions;

export default formSlice.reducer;
